module.exports = __webpack_public_path__ + "static/media/neritoLogoGreen.96971e44.svg";